import { selectAttachmentsGroupPlaceholderNode } from '@newStore/documentUI/transformContent/attachmentSelectors';
import { selectValidateChildrenAreRequired } from '@newStore/validation/validationRules/childrenAreRequired';
import { validateGlobalDocumentAllowedInAttachmentsGroup } from '@newStore/validation/validationRules/globalDocumentSecurityConsistency';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { attachmentGroupTypeComponent } from '@nodeTypeConfig/helpers/editComponents/attachmentGroupTypeComponent';
import { proWebFacetPlaceHolderComponent } from '@nodeTypeConfig/helpers/editComponents/proWebFacetComponent';

const ATTACHMENTS_GROUP: BuildingBlockNodeConfig = {
  nodeSelector: selectAttachmentsGroupPlaceholderNode,
  validationRules: [
    selectValidateChildrenAreRequired,
    validateGlobalDocumentAllowedInAttachmentsGroup,
  ],
  information: {
    single: 'Bijlagegroep',
    plural: 'Bijlagegroep',
    description:
      'Download or bijlagegroep that is a building block (as opposed to PAGE_ATTACHMENTS_GROUP) and appears inline in the document',
    ribbonTitle: 'Bijlagegroep',
    ribonIcon: require('../../../../img/buildingBlocks/ATTACHMENTS_GROUP.svg'),
  },
  buildingBlocks: [
    {
      type: NodeType.ATTACHMENT,
    },
    {
      type: NodeType.GLOBAL_DOCUMENT,
    },
  ],
  edit: [attachmentGroupTypeComponent, proWebFacetPlaceHolderComponent],
  addAccessRightsToAudienceTab: true,
  isCollapsible: false,
  confirmDelete: true,
  showPlaceholder: true,
  onNewNodeDropped: {
    openAside: false,
  },
};

export default ATTACHMENTS_GROUP;
